import { render, staticRenderFns } from "./SaveAssignmentsButton.vue?vue&type=template&id=4ad89fd4&"
import script from "./SaveAssignmentsButton.vue?vue&type=script&lang=js&"
export * from "./SaveAssignmentsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports